import { gql } from "@apollo/client";

export const GET_COLLECTION_SUMMARY = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $lockerIds: [Int]
    $paymentCurrency: String
  ) {
    collectionSummary(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      lockerIds: $lockerIds
      paymentCurrency: $paymentCurrency
    ) {
      lockerId
      lockerName
      paymentCurrency
      doorSize
      totalPodAmount
      totalStorageAmount
      totalOverstayAmount
      totalAmount
      totalPodTransactions
      totalStorageTransactions
      totalOverstayTransactions
      totalTransactions
      podPercent
      storagePercent
      overstayPercent
    }
  }
`;
